// extracted by mini-css-extract-plugin
export var pillWrapper = "_nq-0";
export var showOverflow = "_nq-1";